import React, { useEffect, useState } from 'react'
import { Button, Card, Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationListStandalone, PaginationProvider, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { useHistory, Link } from 'react-router-dom'
import { FaEye, FaEdit, FaTrash, FaPlus } from 'react-icons/fa';

import './index.css'
import { Fetcher } from '../../Helpers/fetcher';
import { Notify } from '../../Helpers/notification';
import { formatDateTime } from '../../Helpers/utils';

const AclList = ({ app }) => {
    const apiPath = app.apiPath;
    const userId = app.userId;
    const history = useHistory();

    const [aclList, setAclList] = useState([])
    const [loading, setLoading] = useState(true);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const getAclList = async () => {
        try {
            setLoading(true)
            const res = await Fetcher.get(`${apiPath}/api/obd/acl/setting/list/${userId}`)
            const data = Array.isArray(res) ? res : []
            setAclList(data)
        } catch (error) {
            Notify.notify("Error while getting the module list")
            console.log("getAclList", error)
        } finally {
            setLoading(false)
        }
    }

    const confirmDelete = async () => {
        if (!selectedRow?.id) {
            Notify.notify("No Id selected");
            return;
        }
        const payload = { id: selectedRow?.id, status: 0 }
        try {
            const res = await Fetcher.post(`${apiPath}/api/obd/delete/acl/settings`, {
                method: "POST",
                headers: { "Content-type": "application/json" },
                body: JSON.stringify(payload)
            })

            if (res.message !== 'Parameters Incorrect') {
                Notify.notify(res.message);
                getAclList()
            }
        } catch (error) {
            Notify.notify("Error while Deleting the acl")
            console.log("confirmDelete", error)
        } finally {
            setShowDeleteModal(false);
            setSelectedRow(null);
        }

    }

    useEffect(() => {
        getAclList()
    }, [])
    const columns = [
        {
            dataField: 'aclName',
            text: 'ACL Name',
            sort: true,
            hidden: false
        },
        {
            dataField: 'status',
            text: 'Status',
            sort: true,
            hidden: false,
            formatter: (cell, row) => {
                const status = (row.status)
                return status === 1 ? "Active" : "Inactive"
            }
        },
        {
            dataField: 'createdAt',
            text: 'Created At',
            sort: true,
            hidden: false,
            formatter: (cell, row) => {
                const date = formatDateTime(row.createdAt)
                return date ?? "-"
            }
        },
        {
            dataField: 'actions',
            text: 'Actions',
            isDummyField: true,
            formatter: (cell, row) => {
                return (
                    <div className="d-flex align-items-center gap-3 acl-action-icons">
                        <FaEye
                            title="View"
                            onClick={() => history.push(`/view-acl-settings/${row.id}`)}
                        />
                        <FaEdit
                            title="Update"
                            onClick={() => history.push(`/update-acl-settings/${row.id}`)}
                        />
                        <FaTrash
                            title="Delete"
                            className="text-danger"
                            onClick={() => {
                                setSelectedRow(row);
                                setShowDeleteModal(true);
                            }}
                        />
                    </div>
                );
            }
        }
    ];

    const { SearchBar, ClearSearchButton } = Search;
    const defaultSorted = [{
        dataField: 'createdAt',
        order: 'desc'
    }];
    const paginationOption = {
        custom: true,
        totalSize: aclList.length,
        sizePerPage: 10,
        sizePerPageList: [10, 25, 50, 100],
    };


    return (
        <Card>
            <Card.Header>ACL List</Card.Header>
            <Card.Body>

                <div className="user-list-table-cont">
                    <PaginationProvider pagination={paginationFactory(paginationOption)}>
                        {
                            ({
                                paginationProps,
                                paginationTableProps
                            }) => (
                                <ToolkitProvider
                                    keyField="id"
                                    data={aclList}
                                    columns={columns}
                                    search
                                    bootstrap4
                                >
                                    {
                                        props => (
                                            <div className="">
                                                <div className="d-flex justify-content-between align-items-center mb-2">

                                                    <div>
                                                        Show{" "}
                                                        <SizePerPageDropdownStandalone {...paginationProps} />

                                                        <span className="search-cont ms-2">
                                                            <SearchBar {...props.searchProps} />
                                                        </span>

                                                        <ClearSearchButton
                                                            className="btn btn-secondary btn-sm ms-2"
                                                            {...props.searchProps}
                                                        />
                                                    </div>

                                                    {/* RIGHT SIDE BUTTONS */}
                                                    <div className="d-flex align-items-center gap-2">
                                                        <Link to="/create-acl-settings" className="btn btn-primary btn-sm">
                                                            <FaPlus className="me-1" />
                                                            Create New ACL
                                                        </Link>
                                                    </div>
                                                </div>

                                                <hr />
                                                <div className="alc-list-table-wrapper">
                                                    <BootstrapTable
                                                        bordered
                                                        striped
                                                        condensed
                                                        defaultSorted={defaultSorted}
                                                        wrapperClasses="table-responsive alc-list-table-responsive"
                                                        classes="userCampaignList-table"
                                                        {...props.baseProps}
                                                        {...paginationTableProps}
                                                        noDataIndication={"No ACL to show"}
                                                    />
                                                </div>
                                                <PaginationListStandalone {...paginationProps} />
                                            </div>
                                        )
                                    }
                                </ToolkitProvider>
                            )
                        }
                    </PaginationProvider>
                </div>
                <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Delete</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        Are you sure you want to delete?
                    </Modal.Body>

                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => {
                                setShowDeleteModal(false);
                                setSelectedRow(null);
                            }}
                        >
                            Cancel
                        </Button>

                        <Button
                            variant="danger"
                            onClick={confirmDelete}
                        >
                            Delete
                        </Button>
                    </Modal.Footer>
                </Modal>

                {loading && <div className="fetching-data"><img alt="" src="/assets/loading.gif" /></div>}
            </Card.Body>
        </Card>

    )
}

export default AclList